<template>
       
     
       <v-card  elevation="16" variant="outlined" class="mx-auto my-8">
          <v-card-item>
          <v-card-title>Liste des médecins</v-card-title>
     <v-card-text>     
<v-container >
  <v-row  
    align="end"
        no-gutters>
    <v-btn  @click="data={}" route to="/NouveauMedecin" color="#0a42da"
class="text-none ms-1 text-white" >
<v-icon
  class="me-2" >
      mdi-plus</v-icon>Nouveau Medecin</v-btn>  
</v-row>



   
    <v-card>
      
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Rechercher"
        single-line
        hide-details
        style="background-color:#0a42da;color:white ;"
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="listdata"
      :search="search"
      no-data-text="Pas de données disponible"
      items-per-page-text="Nombre d'elements par page"
    >

         
<template v-slot:[`item.actions`]="{ item,index }">
    <v-btn  flat  route :to="'/viewMedecin/'+ item.id">
    <v-icon
        size="small"
        
      >
        mdi-eye
      </v-icon>
      </v-btn>
      <v-btn flat  route :to="'/UpdateMedecin/'+ item.id">
      <v-icon
        size="small"
        class="me-2" 
        
      >
        mdi-pencil
      </v-icon>
      </v-btn>
      <v-btn v-if="isAdmin()"  @click="deleteItem(item,index)">
      <v-icon
        size="small"
        
      >
        mdi-delete
      </v-icon>
      </v-btn>
    </template>
</v-data-table>
  </v-card>
</v-container>
</v-card-text>
</v-card-item>
</v-card>
</template>
<script>
import http from '../http.js'

 export default{
    data() {
        return {
         
            creation:false,
            search: '',
            headers: [{ "title": "Nom", "key": "nom" }, { "title": "Prénom", "key": "prenom" }, { "title": "Email", "key": "email" }, { "title": "Téléphone", "key": "tel" }, { "title": "Actions", "key": "actions" }],
            data: {},
            listdata:[]
        };
    },
    computed() {

      
    },
    mounted() {
      this.list()
        
    },
    methods: {
      list(){
        http
            .get('/api/medecin')
            .then(response => { this.listdata = response.data; });
      },
      valider(){
        
      //alert(JSON.stringify(this.data))
       // if(this.$route.params.id ==undefined){
        
          http.post("/api/medecin",this.data).then( resp=>{this.listdata.push(resp.data);});
         
        // }else{
        //   alert('update')
        //   http.put("/api/patient/"+this.$route.params.id,this.data);
       
        // }
       
       
      },
        modifier(item) {
       
          http.get("/api/medecin/"+item.id).then(resp=>{this.data=resp.data;if(this.data.civilite=='Homme') {this.classHo=this.classH} else this.classFe= this.classF});
          this.creation=true
        },
        supprimer(item) {
            http.get("/api/medecin/" + item.id);
            const index = this.data.indexOf(item);
            this.data.splice(index, 1);
        },
        afficher(item) {
            alert(item.id);
        },
        civility(item){
          this.data.civilite=item;
          if(item=="Homme"){
            return this.classFe=this.class;
          }
          if(item=="Femme"){
            return this.classHo=this.class;
          }
          
        },
        isAdmin(){
            let user =JSON.parse(localStorage.getItem("user"));
           return  user.profil==='admin';
        },
        deleteItem(item,index){

          if(confirm('Etes vous sur de la suppresion du medecin '+item.nom+" "+item.prenom+" ?")){
              http.delete("/api/medecin/"+item.id)
              this.listdata.splice(index, 1);
          }
          

        }
    }

}
</script>